import { PrivateRoute } from "@src/components/routing";
import { loadLazily } from "@src/utils/loadLazily";
import { routes } from "@src/utils/routes";

import { useAdminMenuPriviligesProviderContext } from "./priviligesProviders/AdminMenuPriviligesProvider";

const Accounts = loadLazily(async () => await import("@src/containers/accountManagement"));

const ShiftSearchPage = loadLazily(
  async () =>
    await import("@src/containers/adminShifts/ShiftSearchPage").then((module) => ({
      default: module.ShiftSearchPage,
    }))
);

const Logs = loadLazily(
  async () => await import("@src/containers/logs").then((module) => ({ default: module.Logs }))
);

const TimeclockRequests = loadLazily(
  async () =>
    await import("@src/containers/timeclockrequests").then((module) => ({
      default: module.TimeclockRequests,
    }))
);

const UrgentShiftsNoShowCases = loadLazily(
  async () =>
    await import("@src/containers/urgentShiftsNoShowCases").then((module) => ({
      default: module.UrgentShiftsNoShowCases,
    }))
);

const ProofOfEarnings = loadLazily(async () => await import("@src/containers/proofOfEarnings"));

const PayRates = loadLazily(
  async () =>
    await import("@src/containers/shiftPayments/payRates").then((module) => ({
      default: module.PayRates,
    }))
);

const AdminToolsTimekeepingVideosPage = loadLazily(
  async () =>
    await import("@src/appV2/AdminTools/Page").then((module) => ({
      default: module.AdminToolsPage,
    }))
);

const AdminToolsShiftExplainerPage = loadLazily(
  async () =>
    await import("@src/appV2/AdminTools/ShiftExplainer/components/Page").then((module) => ({
      default: module.ShiftExplainerPage,
    }))
);

const AdminToolsJobsScraperPage = loadLazily(
  async () =>
    await import("@src/appV2/AdminTools/JobsScraper/Page").then((module) => ({
      default: module.JobsScraperPage,
    }))
);

const ManageQualifications = loadLazily(
  async () =>
    await import("@src/appV2/Admin").then((module) => ({
      default: module.ManageQualificationsPage,
    }))
);

const ManageWorkplaceTypes = loadLazily(
  async () =>
    await import("@src/appV2/Admin").then((module) => ({
      default: module.ManageWorkplaceTypesPage,
    }))
);

const ManageSkillsAssessments = loadLazily(
  async () =>
    await import("@src/appV2/Admin").then((module) => ({
      default: module.ManageSkillsAssessmentsPage,
    }))
);

export function AdminRoutes() {
  const adminMenuPriviliges = useAdminMenuPriviligesProviderContext();

  return (
    <>
      <PrivateRoute
        path={routes.adminAccounts}
        component={Accounts}
        isAuthorized={adminMenuPriviliges.accountsSection}
      />

      <PrivateRoute
        path={routes.adminShifts}
        component={ShiftSearchPage}
        isAuthorized={adminMenuPriviliges.shiftsSection?.shiftSearch}
      />

      <PrivateRoute
        path={routes.adminLogs}
        component={Logs}
        isAuthorized={adminMenuPriviliges.shiftsSection?.shiftLogs}
      />

      <PrivateRoute
        path={routes.adminTimeclock}
        component={TimeclockRequests}
        isAuthorized={adminMenuPriviliges.shiftsSection?.timeclockRequests}
      />

      <PrivateRoute
        path={routes.adminUrgentShiftNcns}
        component={UrgentShiftsNoShowCases}
        isAuthorized={adminMenuPriviliges.shiftsSection?.noShows}
      />

      <PrivateRoute
        path={routes.agentProof}
        component={ProofOfEarnings}
        isAuthorized={adminMenuPriviliges.payrollSection?.proofOfEarning}
      />

      <PrivateRoute
        exact
        path={routes.adminShiftPaymentsPayRates}
        component={PayRates}
        isAuthorized={adminMenuPriviliges.payrollSection?.shiftPayments}
      />

      <PrivateRoute
        path={routes.adminToolsTimekeepingVideos}
        component={AdminToolsTimekeepingVideosPage}
        isAuthorized={adminMenuPriviliges.adminToolsSection?.timekeepingVideos}
      />

      <PrivateRoute
        path={routes.adminToolsShiftExplainer}
        component={AdminToolsShiftExplainerPage}
        isAuthorized={adminMenuPriviliges.adminToolsSection?.shiftExplainer}
      />

      <PrivateRoute
        path={routes.adminToolsJobsScraper}
        component={AdminToolsJobsScraperPage}
        isAuthorized={adminMenuPriviliges.adminToolsSection?.jobsScraper}
      />

      <PrivateRoute
        exact
        path={routes.adminManageQualifications}
        component={ManageQualifications}
        isAuthorized={adminMenuPriviliges.staffingSection?.qualifications}
      />

      <PrivateRoute
        exact
        path={routes.adminManageQualifications}
        component={ManageQualifications}
        isAuthorized={adminMenuPriviliges.staffingSection?.qualifications}
      />

      <PrivateRoute
        exact
        path={routes.adminManageWorkplaceTypes}
        component={ManageWorkplaceTypes}
        isAuthorized={adminMenuPriviliges.staffingSection?.workplaceTypes}
      />

      <PrivateRoute
        exact
        path={routes.adminManageSkillsAssessments}
        component={ManageSkillsAssessments}
        isAuthorized={adminMenuPriviliges.staffingSection?.skillAssessments}
      />
    </>
  );
}
